import { render, staticRenderFns } from "./StaffView.vue?vue&type=template&id=3ab05ecd&scoped=true"
import script from "./StaffView.vue?vue&type=script&lang=js"
export * from "./StaffView.vue?vue&type=script&lang=js"
import style0 from "./StaffView.vue?vue&type=style&index=0&id=3ab05ecd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab05ecd",
  null
  
)

export default component.exports